<template>
  <b-container fluid class="incomingContactForms">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          All Incoming Contact Forms
        </div>
      </b-col>
    </b-row>
    <b-row class="m-2">
      <b-col lg="4" md="4" sm="12" xs="12" class="box text-left mb-3 pb-3 pt-2" v-for="(contact, index) in lists" :key="index" :class={even:index%2}>
        <div>Subject : {{contact.subject}}</div>
        <div>Name : {{contact.name}}</div>
        <div>Email : {{contact.email}}</div>
        <div>Phone Number : {{contact.phoneNumber}}</div>
        <div class="text-justify">Message : {{contact.message}}</div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'

export default {
  name: 'incomingContactForms',
  data () {
    return {
      lists: [
        {
          id: '1',
          name: 'Budi',
          email: 'budi@gmail.com',
          phoneNumber: '08528909991',
          message: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
          subject: 'Construction'
        },
        {
          id: '2',
          name: 'Dodi',
          email: 'dodi@yahoo.com',
          phoneNumber: '08528909392',
          message: 'The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.',
          subject: 'Repairment'
        },
        {
          id: '3',
          name: 'Ekanda',
          email: 'ekanda@commerce.com',
          phoneNumber: '08123458909',
          message: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          subject: 'Repairment'
        },
        {
          id: '4',
          name: 'Fendi',
          email: 'fendi@yahoo.com',
          phoneNumber: '08123423423',
          message: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
          subject: 'Construction'
        },
        {
          id: '5',
          name: 'Gilang',
          email: 'gilang@mail.com',
          phoneNumber: '08528909392',
          message: 'quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
          subject: 'Repairment'
        }
      ]
    }
  },
  methods: {
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  }
}
</script>

<style scoped>
.incomingContactForms {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box {
  border-bottom: 1px solid #BDBDBD;
}
.box img {
  width: 100%;
}
.actionBtn {
  float:right;
  margin-top: 5px;
  margin-left: 15px;
  color: #455A64;
}
.actionBtn:hover {
  cursor: pointer;
  color: #000;
  text-decoration: underline;
}
.addBtn {
  background-color: #FF8F00;
  padding: 5px 25px;
  text-transform: capitalize;
  margin-left: 50px;
  color: #fff;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.addBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/IncomingContactForms.vue